/**
 * Module Client #09 — Mes rapports
 */
const moduleClientRapports = {
  id: 'client-mes-rapports',
  population: 'client',
  order: 9,
  category: 'Pilotage',
  title: 'Mes rapports',
  subtitle: 'Exporter KPIs et données pour votre reporting interne',
  icon: 'BarChart3',
  duration: '15 min',
  level: 'Intermédiaire',
  slides: [
    { type: 'cover', eyebrow: 'Module 09 — Client', title: 'Mes rapports', subtitle: 'KPIs personnalisés + exports CSV/PDF', icon: 'BarChart3', duration: '15 min', audience: 'Direction & Gestionnaires', level: 'Intermédiaire' },
    { type: 'intro', title: 'Objectifs', intro: 'Le module Rapports vous permet de générer vos propres tableaux de bord et de les exporter pour vos analyses internes.', objectives: [
      'Créer un rapport personnalisé (KPIs au choix)',
      'Filtrer par période, opération, client, secteur',
      'Exporter en CSV (compatible Excel, Sage, Odoo)',
      'Exporter en PDF (présentations directions)',
      'Planifier l\'envoi automatique par email (hebdo/mensuel)',
    ]},
    { type: 'concept', eyebrow: 'Catalogue', icon: 'BookOpen', title: 'Les 6 rapports prédéfinis',
      bullets: [
        '📈 Activité mensuelle : volume + CA + tendances',
        '💰 Synthèse financière : factures, paiements, retards',
        '🚛 Performance logistique : ponctualité, casse, incidents',
        '🌍 Carte des flux : analyse géographique des trajets',
        '👥 Top opérateurs : performance par opérateur Baobab',
        '⭐ Satisfaction : évolution NPS sur la période',
      ],
      note: 'Vous pouvez aussi créer votre propre rapport custom avec les KPIs de votre choix.',
    },
    { type: 'steps', title: 'Créer un rapport personnalisé', steps: [
      { title: 'Menu "Mes rapports"', detail: 'Sidebar gauche.' },
      { title: 'Bouton "+ Nouveau rapport"', detail: 'En haut à droite.' },
      { title: 'Choisir un template ou "Vierge"', detail: '6 templates pré-construits.' },
      { title: 'Sélectionner les KPIs', detail: 'Drag & drop des indicateurs disponibles.' },
      { title: 'Définir la période et les filtres', detail: 'Date, statut, secteur, client...' },
      { title: 'Sauvegarder et exporter', detail: 'Format CSV / PDF ; envoi automatique configurable.' },
    ]},
    { type: 'comparison', title: 'Quand utiliser quel export ?', do: [
      'CSV : pour traitement Excel ou intégration ERP',
      'PDF : pour réunions, comités, archivage',
      'Envoi automatique : éviter la corvée hebdo',
      'Rapports custom : pour vos analyses spécifiques',
    ], dont: [
      'Ne pas exporter sans définir la période (volumétrie)',
      'Ne pas envoyer par email à toute l\'entreprise (RGPD)',
      'Ne pas modifier le PDF (perte signature)',
      'Ne pas oublier de sauvegarder le rapport (perdu sinon)',
    ]},
    { type: 'quiz', title: 'Quiz',
      question: 'Vous voulez un rapport mensuel automatique. Comment faire ?',
      options: [
        'Demander à votre opérateur',
        'Le créer, puis activer "Envoi programmé" → Mensuel, jour 1, à 9h',
        'Exporter manuellement chaque mois',
        'Utiliser le dashboard',
      ],
      answerIndex: 1,
      explanation: 'L\'envoi programmé automatise totalement. Vous recevrez le PDF dans votre boîte mail tous les 1ers du mois sans intervention.',
    },
    { type: 'takeaways', title: 'À retenir', items: [
      '6 rapports prédéfinis + rapports custom illimités.',
      'CSV pour ERP, PDF pour direction.',
      'Envoi automatique = gain de temps maximal.',
      'Exports cohérents avec les KPIs du dashboard.',
    ]},
    { type: 'cta', title: 'Module 09 terminé !', actions: [
      { label: 'Mes rapports', href: '/rapports' },
      { label: 'Catalogue', href: '/docs/client/training' },
    ]},
  ],
};
export default moduleClientRapports;
